export default {
  methods: {

    /**
     * Returns value for the key provided according to the selected language
     * @param {String} key
     * @param {Object} contentObject
     * @returns {String}
     */
    c: function (key, contentObject = this.content) {
      var lang = this._getSelectedLanguage()

      if (typeof key !== 'string') {
        return
      }

      return contentObject[key][lang]
    },

    /**
     * Returns language selected in the route
     * @default 'en'
     * @returns {String}
     */
    _getSelectedLanguage: function () {
      return (typeof this.$route.params.lang !== 'undefined') ? this.$route.params.lang : 'en'
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Translation.js